/**
 * HTML escaping for EPUB and the other HTML export fragments
 * (copyright, dedication, scene breaks, map figures).
 *
 * Desktop book PDF does not use this file. The Paged.js document shell
 * that used to live here was removed with the WKWebView capture path (#291).
 */
export function escapeHtmlText(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
